import { db } from "@/main";

export default {
    state: {
      list: [],
      roles: [
        {
          label: 'Chofer',
          value: 'driver',
          desc: 'Puede ver los pedidos y editar el estado y la cantidad del pedido'
        },
        {
          label: 'Administrativo',
          value: 'commercial',
          desc: 'Puede ver los pedidos y editar el número de manifiesto'
        },
        {
          label: 'Administrador',
          value: 'admin',
          desc: 'Tiene control total del sistema'
        },
        {
          label: 'Administrador General',
          value: 'superuser',
          desc: 'Tiene control total del sistema'
        },
      ]
    },
    mutations: {
      ADD_ROLE(state, role) {
        state.list.push(role)
      },
      UPDATE_ROLE(state, role) {
        let index = state.list.findIndex(
          obj => obj.id == role.id
        );
        state.list.splice(index, 1, role);
      },
      DELETE_ROLE(state, role ) {
        let index = state.list.findIndex(
          obj => obj.id == role.id
        );
        state.list.splice(index, 1);
      },
      CLEAR_ROLES(state) {
        state.list = []
      }
    },
    actions: {
      getRoles( { state, commit } ) {
        if( state.list.length == 0 ) {
          return db.collection("roles").get().then(function(querySnapshot) {
            //commit('CLEAR_ROLES')
            querySnapshot.forEach(function(doc) {
                const role = doc.data()
                role.id = doc.id
                
                const r = state.roles.find( e => e.value === role.role )
                role.role_t = r.label
                role.desc = r.desc

                const roleTmp = state.list.find( e => e.id === role.id )
                if( !roleTmp )                                                                
                  commit('ADD_ROLE', role)
            });
          });
        }
      },
      addRole( { state, commit }, role ) {
        delete role.re_password
        
        return new Promise((resolve, reject) => {
          db.collection("roles")
          .add(role)
          .then(function(docRef) {
            role.id = docRef.id;

            const r = state.roles.find( e => e.value === role.role )
            role.role_t = r.label
            role.desc = r.desc

            commit( 'ADD_ROLE', role )
            resolve()
          })
          .catch(function(error) {
            commit('SET_ERROR', { section: 'Roles', function: 'addRole', msg: error });
            reject()
          })
        })
      },
      updateRole( { state, commit }, role ) {
        delete role.role_t
        delete role.desc

        return new Promise((resolve, reject) => {
          db.collection("roles")
          .doc(role.id)
          .update(role)
          .then(() => {
            const r = state.roles.find( e => e.value === role.role )
            role.role_t = r.label
            role.desc = r.desc

            commit( 'UPDATE_ROLE', role )
            resolve()
          })
          .catch(function(error) {
            commit('SET_ERROR', { section: 'Roles', function: 'updateRole', msg: error });
            reject()
          })
        })
      },
      deleteRole( { commit }, role ) {
        return new Promise((resolve, reject) => {
          db.collection("roles")
          .doc(role.id)
          .delete()
          .then(function() {
            commit( 'DELETE_ROLE', role )
            resolve()
          })
          .catch(function(error) {
            commit('SET_ERROR', { section: 'Roles', function: 'deleteRole', msg: error });
            reject()
          });
        })
      },
      toggleStatusRole( { commit }, role ) {
        role.is_active = !role.is_active
        return new Promise((resolve, reject) => {
          db.collection("roles")
          .doc(role.id)
          .update({
            is_active: role.is_active
          })
          .then(function() {
            commit( 'UPDATE_ROLE', role )
            resolve()
          })
          .catch(function(error) {
            commit('SET_ERROR', { section: 'Roles', function: 'toggleStatusRole', msg: error });
            reject()
          });
        })
      }
    }
}
  